import type { Set } from "@/types";

export const toDiceNotationString = (set: Set, constant: number) => {
  let notation: string = "";

  // Iterate dice terms
  if (set && set.length > 0) {
    notation = set
      .map((s) => {
        if (!s) return "";

        return `${s.count}${s.dieType}`;
      })
      .filter((s) => s !== "")
      .join("+");
  }

  // Append constant
  if (constant != 0) {
    if (set.length > 0) {
      notation += constant > 0 ? `+${constant}` : constant;
    } else {
      notation = `${constant}`;
    }
  }

  return notation;
};
